import { render, staticRenderFns } from "./VProjectRating.vue?vue&type=template&id=77f6354e&"
import script from "./VProjectRating.vue?vue&type=script&lang=js&"
export * from "./VProjectRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports